var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgECommerce(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 519.92 413.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#ccc;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 519.92,
    height: 413.48
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M211.67,404a41.44,41.44,0,1,1,41.44-41.43A41.48,41.48,0,0,1,211.67,404Zm0-61.78A20.35,20.35,0,1,0,232,362.57,20.37,20.37,0,0,0,211.67,342.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M410.37,404a41.44,41.44,0,1,1,41.44-41.43A41.48,41.48,0,0,1,410.37,404Zm0-61.78a20.35,20.35,0,1,0,20.35,20.35A20.37,20.37,0,0,0,410.37,342.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M172.71,310.39A59.38,59.38,0,0,1,115,264.45L69.61,66.78A16.19,16.19,0,0,1,85.39,47H473.17a16.22,16.22,0,0,1,16.2,16.2V207.39a58.93,58.93,0,0,1-49.78,58.43L182.1,309.64A58.73,58.73,0,0,1,172.71,310.39ZM91.53,68.05l44,191.68a38.23,38.23,0,0,0,43.16,29.11L436.2,245a37.94,37.94,0,0,0,32.08-37.62V68.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M91.94,127.58a10.55,10.55,0,0,1-10.23-8l-21.85-89H10.54a10.55,10.55,0,0,1,0-21.09H76.39l25.8,105a10.56,10.56,0,0,1-10.25,13.06Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgECommerce);
export default __webpack_public_path__ + "static/media/e-commerce.322cfae3b9747a6a8fdf83f2f45dd54a.svg";
export { ForwardRef as ReactComponent };